import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/industries.css"
// Import industry images
import hotel from "../assets/images/Industries/hotel.jpg";
import hospital from "../assets/images/Industries/hospital.jpg";
import factories from "../assets/images/Industries/factories.jpg";
import office from "../assets/images/Industries/office.jpg";
import institution from "../assets/images/Industries/institutions.jpg";
import shop from "../assets/images/Industries/shop.jpg";
import malls from "../assets/images/Industries/malls.jpg";
import homes from "../assets/images/Industries/homes.jpeg";

// Industry data with more detailed descriptions
const industries = [
  {
    name: "Home",
    image: homes
  },
  {
    name: "Factories",
    image: factories
  },
  {
    name: "Hospitals",
    image: hospital
  },
  {
    name: "Hotels",
    image: hotel
  },
  {
    name: "Office",
    image: office
  },
  {
    name: "Institutions",
    image: institution
  },
  {
    name: "Shops",
    image: shop
  },
  {
    name: "Malls",
    image: malls
  }
];

const Industries = () => {
  return (
    <section className="industries-section py-5">
      <div className="container">
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h2 className="section-title">Industries We Serve</h2>
          </div>
        </div>

        {/* Desktop view - Grid display */}
        <div className="d-none d-md-block">
          <div className="row">
            {industries.map((industry, index) => (
              <div className="col-md-6 col-lg-3 mb-4" key={index}>
                <div className="industry-card">
                  <div className="industry-image-container">
                    <img 
                      src={industry.image} 
                      alt={industry.name} 
                      className="industry-image"
                    />
                    <div className="industry-overlay">
                      <h4 className="industry-name">{industry.name}</h4>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile view - Swiper carousel */}
        <div className="d-md-none">
          <Swiper
            modules={[Pagination, Autoplay, Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            navigation
            className="industries-swiper"
          >
            {industries.map((industry, index) => (
              <SwiperSlide key={index}>
                <div className="industry-card">
                  <div className="industry-image-container">
                    <img 
                      src={industry.image} 
                      alt={industry.name} 
                      className="industry-image"
                    />
                    <div className="industry-overlay">
                      <h4 className="industry-name">{industry.name}</h4>
                    </div>
                  </div>
                  {/* <div className="industry-content">
                    <p className="industry-description">{industry.description}</p>
                  </div> */}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Industries;